export default ['$q', 'JsonRPCService', ($q, JsonRPCService) => {
    return {
        findSubmissionsByCreateUser: () => {
            return JsonRPCService.send('pc', 'gateway/submission', 'findSubmissionsByCreateUser', []);
        },

        findSubmissionByCreateUserOpenedWithinNumberOfDays: (numberOfDays) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'findSubmissionByCreateUserOpenedWithinNumberOfDays', [numberOfDays]);
        },

        findSubmissionsByAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'findSubmissionsByAccount', [accountNumber]);
        },

        findJobByJobNumber: (jobNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'findJobByJobNumber', [jobNumber]);
        },

        withdrawJobByJobNumber: (jobNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'withdrawJobByJobNumber', [jobNumber]);
        },
        getOpenJobsByJobTypeForCurrentUser: (jobType) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'getOpenJobsByJobTypeForCurrentUser', [jobType]);
        },
        findSubmissionSummariesByAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/submission', 'findSubmissionSummariesByAccount', [accountNumber]);
        }
    };
}];